import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group cursor-pointer"
          aria-label="极速高清首页"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg group-hover:bg-primary-600 transition-colors">
            <i className="ri-play-circle-fill text-background-50 text-xl"></i>
          </div>
          <span className={`font-heading text-xl font-bold whitespace-nowrap ${isScrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
            极速高清
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? isScrolled ? 'bg-primary-100 text-primary-700' : 'bg-white/20 text-white'
                : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? isScrolled ? 'bg-primary-100 text-primary-700' : 'bg-white/20 text-white'
                  : isScrolled
                  ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/80 hover:text-white'
            }`}
          >
            关于我们
          </Link>
          <Link
            to="/category/dianying"
            className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即观看
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl ${isScrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">关于我们</Link>
            <Link to="/category/dianying" className="mt-2 px-5 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium text-center hover:bg-primary-600 cursor-pointer">
              立即观看
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}